import React, { Component } from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import { browserName, browserVersion } from 'react-device-detect';
import  CounPF  from './counControlFold/counPF';
import  CounTX  from './counControlFold/counTX';
import Switch from 'react-switch';
import { connect } from 'react-redux';


class CounselorControl extends Component {
    static displayName = CounselorControl.name;

    constructor(props) {
        super(props);
        this.state = {
            loading: false,
            returnable: this.props.reduxData.userInfo,
            browser: `${browserName}${browserVersion}`,
            ip: "",
            globalLevel: "",
            permissionFlag: true,
            activeBool: false
        }
        this.toggleSwitch = this.toggleSwitch.bind(this);
        this.testPermission();
    }

    async getData() {
        const response = await fetch('https://api.ipify.org?format=json', { dataType: 'jsonp' });
        const data = await response.json();
        this.setState({
            ip: data.ip
        })
        this.getUserInfo();
    }

    async getUserInfo() {
        //let bearerVAR = "Bearer " + localStorage.getItem("webApiAccessToken");
        //let bearerVAR = "Bearer " + this.props.reduxData.apiKey
        //this.props.updateFetchTime();
        //fetch('user', { method: 'GET', headers: { 'Authorization': bearerVAR } })
        //    .then((response) => response.json())
        //    .then((responseJSON) => { this.writeUserData(responseJSON) })
        //    //.then((responseLog) => { this.recordComingHere() })
        //    .then((responseState) => { this.testPermission() })
        ////localStorage.setItem("lastFetch", moment());
        //I'm not gonna lie, it's a little embarrassing that it took me about a year to remember .then() exists
        this.writeUserData(this.props.reduxData.userInfo)
    }

    writeUserData(input) {
        this.setState({
            returnable: input
            })
    }

    //async recordComingHere() {
    //    let bearerVAR = "Bearer " + localStorage.getItem("webApiAccessToken");
    //    let toSend = {
    //        pagePK: "1033",
    //        department: this.props.reduxData.userInfo.level,
    //        userPCID: this.props.reduxData.userInfo.pcid,
    //        ip: this.state.ip,
    //        browser: this.state.browser,
    //        userID: this.props.reduxData.userInfo.username
    //    }
    //    const response = await fetch('logging', {
    //        method: 'POST',
    //        headers: { 'Content-Type': 'application/json', 'Authorization': bearerVAR },
    //        body: JSON.stringify(toSend)
    //    });
    //    const data = await response.json();
    //    localStorage.setItem("lastFetch", moment());
    //}

    async testPermission() {
        //let bearerVAR = "Bearer " + localStorage.getItem("webApiAccessToken");
        let bearerVAR = "Bearer " + this.props.reduxData.apiKey
        this.props.updateFetchTime();
        let toSend = {
            userLevel: this.props.reduxData.userInfo.level.pk,
            pagepk: "1033"
        }
        const response = await fetch('ValidDepartments', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Authorization': bearerVAR },
            body: JSON.stringify(toSend)
        })
        const data = await response.json();
        //localStorage.setItem("lastFetch", moment());
        this.setState({
            permissionFlag: data
        })
    }

    componentDidMount() {
        
    }

    toggleSwitch() {
        this.setState({
            activeBool: !this.state.activeBool
        })
    }

    render() {
        if (this.state.permissionFlag == false) {
            this.props.passNewPage(-1);
        }
        //if (this.props.justSwitch == true) {
        //    this.props.passNewPage(1);
        //}
        let displayPage = <div></div>
        if (this.state.activeBool == false) displayPage = <CounPF />; else displayPage = <CounTX />
        return (
            <div>
                <div className='d-flex float-right' style={{ float: 'right' }}>
                    PowerFAIDS &nbsp;<Switch uncheckedIcon={false} checkedIcon={false} onChange={this.toggleSwitch} checked={this.state.activeBool} onColor={'#888'} height={25} width={50} />&nbsp; TargetX
                </div>
                {displayPage}
            </div>
            )       
    }
}

const mapStateTo = state => ({
    reduxData: state
})

const mapDispatchTo = (dispatch) => {
    return {
        updateFetchTime: () => dispatch({ type: 'foundation/setFetchTime' })
    }
}

export default connect(mapStateTo, mapDispatchTo)(CounselorControl);